export default __webpack_public_path__ + "static/media/mid5.fc4ad55d.jpg";